/**
 * FairwayBid – die Stückzahl außerhalb der Range-Bälle
 *
 * Bis jetzt hatte nur eine einzige Kategorie ein Mengenfeld: Range-Bälle, als
 * Auswahl fester Staffeln, weil dort die Menge über den Preis entscheidet.
 * Überall sonst stand die Stückzahl im Beschreibungstext – "24 Abschlagmatten",
 * "drei elektrische Golf-Carts".
 *
 * Als Fließtext kann niemand damit rechnen. Konkret fehlte damit dreierlei:
 *
 *   - Der Bündel-Pool konnte für Ballautomaten, Matten oder Carts keine
 *     Gesamtmenge zeigen – also auch kein Argument für ein Bündel.
 *   - Wer sich anhängen wollte, musste die Stückzahl im Formular suchen und
 *     hätte dort etwas ganz anderes eintragen können.
 *   - Ein Händler kann nicht danach filtern und nicht danach kalkulieren.
 *
 * Deshalb ein einfaches Zahlenfeld für alle Kategorien außer Range-Bällen –
 * dort bleibt die Staffel, weil sie dort mehr sagt als eine freie Zahl.
 *
 * Das Feld steht im Code und nicht in der Console: Erweiterte Daten sind bei
 * Sharetribe schemalos, die Console-Feldliste steuert nur die Eingabemaske.
 * Trägt jemand später denselben Schlüssel dort ein, gewinnt die Console.
 */
import { CATEGORY_LABELS } from './matching';

export const MENGE_KEY = 'menge';

/** Die Kategorie mit eigener Mengenstaffel – sie bekommt kein zweites Feld. */
export const KATEGORIE_MIT_STAFFEL = 'range-golfballs-listing-type';

/** Alle übrigen Kategorien. Quelle ist CATEGORY_LABELS, keine zweite Liste. */
export const MENGE_KATEGORIEN = Object.keys(CATEGORY_LABELS).filter(
  k => k !== KATEGORIE_MIT_STAFFEL
);

export const FWB_QUANTITY_FIELD = {
  key: MENGE_KEY,
  scope: 'public',
  schemaType: 'long',
  // Eins bis tausend: Darunter ist es keine Anfrage, darüber ist es ein
  // Tippfehler. Beides schützt die Summe im Bündel-Pool vor Unsinn.
  numberConfig: { minimum: 1, maximum: 1000 },
  helpText:
    'Wie viele Stück Sie brauchen. Steht die Zahl hier statt nur im Text, können sich andere Anlagen an Ihre Anfrage anhängen und Anbieter eine Sammelbestellung rechnen.',
  showConfig: { label: 'Stückzahl', displayInProfile: true },
  saveConfig: {
    label: 'Stückzahl',
    placeholderMessage: 'z. B. 24',
    isRequired: false,
  },
  filterConfig: { indexForSearch: true, label: 'Stückzahl' },
  categoryConfig: { limitToCategoryIds: true, categoryIds: MENGE_KATEGORIEN },
};

/** Die Mengenstaffel der Range-Bälle – eine Auswahl, kein freies Feld. */
export const STAFFEL_KEY = 'listing_how_many_range_golfballs';

/**
 * In welchem Feld die Stückzahl dieser Kategorie steht.
 *
 * Zwei Felder, weil die Menge zweierlei bedeutet: Bei Range-Bällen ist sie
 * eine Preisstaffel und deshalb eine Auswahl, überall sonst eine schlichte
 * Zahl.
 */
export const mengenfeldFuer = kategorie =>
  kategorie === KATEGORIE_MIT_STAFFEL ? STAFFEL_KEY : MENGE_KEY;

/** Steht in diesen Formularwerten eine Stückzahl? */
export const hatMenge = (values = {}, kategorie = null) => {
  const wert = values[`pub_${mengenfeldFuer(kategorie)}`];
  if (wert === null || wert === undefined || wert === '') return false;
  if (typeof wert === 'string') return wert.trim().length > 0;
  return true;
};

/** Hängt das Feld an – die Console gewinnt, falls es dort schon steht. */
export const mitMengenfeld = (listingFields = []) =>
  listingFields.some(f => f?.key === MENGE_KEY)
    ? listingFields
    : [...listingFields, FWB_QUANTITY_FIELD];
